import { LoadingButton as MLoadingButton, LoadingButtonProps } from '@mui/lab/'

export const LoadingButton: React.FC<LoadingButtonProps> = (props) => {
  return <MLoadingButton {...props} />
}
